import React from 'react';

const SvgBasc = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 43" {...props}>
    <path d="M31.58 38.828s-13.334-2.403-13.334-11.545c-.002-7.29 9.87-10.504 13.334-11.45v22.995zm0-23.423c-8.015-.58-26.185 3.176-26.185 11.397 0 5.36 9.62 13.198 25.29 13.402.62 0 18.42-.689 18.146-19.794C48.6 4.362 36.588 1.553 32.748 1.06V.086c15.312.973 27.355 10.18 27.355 21.356 0 11.822-13.47 21.443-30.035 21.443-16.564 0-29.965-9.621-29.965-21.443C.103 9.62 13.505 0 30.068 0c.506 0 1.011.01 1.512.027v15.378z" />
  </svg>
);

export default SvgBasc;
